import React from 'react';
import { useTranslation } from 'react-i18next';

const PriceList = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="py-2">
        <div className="container">
          <h2 className="center p-1">{t('Price List')}</h2>
          <div className="bottom-line"></div>

          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <article className="card">
                <div>
                  <table className="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th scope="col">{t('Form Type')}</th>
                        <th scope="col">{t('Price')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{t('First page')}</td>
                        <td>
                          <strong>{t('$250')}</strong> <span className="text-muted">{t('including GST')}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>{t('Additional Page (2-99 pages)')}</td>
                        <td>
                          <strong>
                            {t('$75')} {t('each')}
                          </strong>{' '}
                          <span className="text-muted">{t('including GST')}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>{t('Disability Form')}</td>
                        <td>
                          <strong>{t('$750')}</strong> <span className="text-muted">{t('including GST')}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div className="mt-4">
                    <p className="text-center">
                      <strong>{t('Note:')}</strong> {t('Form completion is not covered by MSP. Fees vary depending on complexity and will be confirmed before we begin.')}
                    </p>

                    <div className="alert alert-info">
                      <h5>{t('💡 Examples:')}</h5>
                      <ul className="mb-0">
                        <li>
                          1-page form: <strong>$250</strong>
                        </li>
                        <li>
                          3-page form: <strong>$400</strong> ({t('$250')} + {t('$75')} + {t('$75')})
                        </li>
                        <li>
                          Disability application: <strong>{t('$750')}</strong> {t('(flat rate)')}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PriceList;
